var map = {
	"./aqi_ca.jpg": "0eb7",
	"./aqi_en.jpg": "4cf1",
	"./aqi_es.jpg": "eccb",
	"./battery_ca.jpg": "b95c",
	"./battery_en.jpg": "ccf3",
	"./battery_es.jpg": "a828",
	"./cbattery_ca.jpg": "5cbb",
	"./cbattery_en.jpg": "51d5",
	"./cbattery_es.jpg": "c0f6",
	"./co2_ca.jpg": "d044",
	"./co2_en.jpg": "2c15",
	"./co2_es.jpg": "fcf7",
	"./co_ca.jpg": "3f1e",
	"./co_en.jpg": "2a56",
	"./co_es.jpg": "a35f",
	"./footer2.jpg": "4166",
	"./light.jpg": "959a",
	"./llum.jpg": "812b",
	"./luz.jpg": "9d87",
	"./no2_ca.jpg": "6b39",
	"./no2_en.jpg": "b4da",
	"./no2_es.jpg": "7eec",
	"./noise_ca.jpg": "57aa",
	"./noise_en.jpg": "9137",
	"./noise_es.jpg": "5b8e",
	"./o3_ca.jpg": "1ba7",
	"./o3_en.jpg": "d5cb",
	"./o3_es.jpg": "2a6f",
	"./pm10_ca.jpg": "6246",
	"./pm10_en.jpg": "0f0d",
	"./pm10_es.jpg": "b756",
	"./pm25_ca.jpg": "918a",
	"./pm25_en.jpg": "e42e",
	"./pm25_es.jpg": "583e",
	"./powerled_ca.jpg": "dbb7",
	"./powerled_en.jpg": "b6dd",
	"./powerled_es.jpg": "fca6",
	"./rh_ca.jpg": "f998",
	"./rh_en.jpg": "4b71",
	"./rh_es.jpg": "0945",
	"./so2_ca.jpg": "db23",
	"./so2_en.jpg": "e3d7",
	"./so2_es.jpg": "2543",
	"./t_ca.jpg": "76ec",
	"./t_en.jpg": "a85b",
	"./t_es.jpg": "f9c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";